export default __webpack_public_path__ + "static/media/nba-header-background.0e3efcf1.png";